import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencyValue } from '../../data/utils/getCurrencyValue';
import { getLabel } from '../../data/labels';

function BetOptionsSection(props) {
	const betslipContext = useContext(BetslipContext) ;
    
	const couponKey = props.couponKey;
    let betslipData = betslipContext.getBetslipData();
    const coupon = betslipData.coupons[couponKey];
    const selectedContainer = coupon.selectedContainer;
    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;
    
    const checkedValue = betslipContext.getBetOptionsSelection().value;
    
    function selectRadio(value, type) {
    	betslipContext.setBetOptionsSelection(value, type);
    }
    
    const data = betslipContext.getBetOptionsData();
    const betOptionsData = data == null ? {funbonuses: [], freebets : [], realMoneyAmount : 0} : data;
    const realMoneyAmount = betOptionsData.realMoneyAmount;
    function purchase() {
    	if (checkedValue === 'REAL') {
    		// revalidate amounts
    		const result = betslipContext.validateCoupon(false);
    		if (result.validated) {
    			betslipContext.purchase();
    		} else {
    			betslipContext.removeBetOptionsSection();
    			betslipContext.setCartError(result.errorMessage);
    		}
    	} else {
    		betslipContext.purchase();
    	}
    }
    
    return (
        <React.Fragment key={`${selectedContainer}-bet-options-section`}>
            {betOptionsData.freebets.length > 0 &&
                <div className="cartEvent cartEvent--bonus">
                    <div className="cartEvent__header">
                        <div className="cartEvent__title">
                            <div className="cartEvent__title">
                                {getLabel('betslip_alt.freebet.title_part1')} {getLabel('betslip_alt.freebet.title_part2')}:
                            </div>
                        </div>
                    </div>
                    <div className="cartEvent__body">
                        <div className="cartEvent__body__content">
                            {betOptionsData.freebets.map(betOption => {
                                const reactKey = `${selectedContainer}-bonus-${betOption.id_bonus}`;
                                return (
                                    <div key={`bet-option-${betOption.id_bonus}`} className={"bonus-schedina_template-1_body_card" + (betOption.importo > 0 ? '' : ' d-none')}>
                                        <div className="cartEvent__body__grid">
                                            <label htmlFor="xs-freebet-radio-btn" className="cartEvent__body__grid__left">
                                                <p>{betOption.sigla_promo} - {betOption.id_bonus}</p>
                                                <p>{getLabel('betslip_alt.freebet.total_amount')}: {getCurrencyValue(betOption.importo, mult, nDec, currency)}</p>
                                            </label>
                                            <div className="cartEvent__body__grid__right">
                                                <input checked={checkedValue == betOption.id_bonus + ""} 
                                                       onChange={() => {selectRadio(betOption.id_bonus + "", betOption.type)}} 
                                                       type="radio" 
                                                       className="pointer" 
                                                       name={reactKey}
                                                       key={reactKey}
                                                       value={reactKey}
                                                       id="xs-freebet-radio-btn" />
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            }
            <div className="cartEvent cartEvent--bonus">
                <div className="cartEvent cartEvent--bonus">
                    <div className="cartEvent__header">
                        <div className="cartEvent__title">
                            <div className="cartEvent__title">
                                {getLabel('betslip_alt.fun_bonus.use_real_money_prompt')}
                            </div>
                        </div>
                    </div>
                    <div className="cartEvent__body">
                        <div className="cartEvent__body__content">
                            <div className="cartEvent__body__grid">
                                <label htmlFor="xs-real-money-radio-btn" className="cartEvent__body__grid__left">
                                    <p>{getLabel('betslip_alt.fun_bonus.real_money')}: {getCurrencyValue(realMoneyAmount, mult, nDec, currency)}</p>
                                </label>
                                <div className="cartEvent__body__grid__right">
                                    <input className="pointer" 
                                           checked={checkedValue === "REAL"} 
                                           type="radio" 
                                           name={`${selectedContainer}-bet-option-REAL`}
                                           key={`${selectedContainer}-bet-option-REAL`}
                                           value={`${selectedContainer}-bet-option-REAL`}
                                           onChange={() => selectRadio('REAL', null)}
                                           id="xs-real-money-radio-btn" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bonus-schedina_template-1">
                <div className="bonus-schedina_template-1_body">
	            	{betOptionsData.funbonuses.length > 0 &&
                        <div className="bonus-schedina_template-1_body_title">
                            <p>{getLabel('betslip_alt.fun_bonus.title_part1')} <span>{getLabel('betslip_alt.fun_bonus.title_part2')}</span>:</p>
                        </div>
                	}
                    {betOptionsData.funbonuses.map(betOption => {
                        const perc = (betOption.importo_giocato * 100) / betOption.importo_da_giocare;
                        const reactKey = `${selectedContainer}-bonus-${betOption.id_bonus}`;
                        return (
                            <div key={"bet-option-" + betOption.id_bonus} className={"bonus-schedina_template-1_body_card" + (betOption.importo > 0 ? '' : ' d-none')}>
                                <div className="bonus-schedina_template-1_body_card_title">
                                    <p>{betOption.sigla_promo}</p>
                                    <input checked={checkedValue == betOption.id_bonus + ""} 
                                        onChange={() => selectRadio(betOption.id_bonus + "", betOption.type)}
                                        type="radio" 
                                        className="pointer" 
                                        name={reactKey}
                                        key={reactKey}
                                        value={reactKey} />
                                </div>
                                <div>
                                    <p>{getLabel('betslip_alt.fun_bonus.remaining_balance')} {getCurrencyValue(betOption.importo, mult, nDec, currency)}</p>
                                </div>
                                <div className="bonus-schedina_template-1_body_card_progress progress">
                                    <div className="progress-bar" role="progressbar" style={{ width: perc + '%'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                    <p className="bonus-schedina_template-1_body_card_progress_text">
                                        {getCurrencyValue(betOption.importo_giocato, mult, nDec, currency)}
                                        / 
                                        {getCurrencyValue(betOption.importo_da_giocare, mult, nDec, currency)} 
                                    </p>
                                </div>
                                <div className="bonus-schedina_template-1_body_card_range">
                                    <p>{getLabel('betslip_alt.fun_bonus.min')} {getCurrencyValue(betOption.min_bet, mult, nDec, currency)}</p>
                                    <p>{getLabel('betslip_alt.fun_bonus.max')} {getCurrencyValue(betOption.max_bet, mult, nDec, currency)}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="bonusButtonsContainer">
                <button className="bonusButton" onClick={() => betslipContext.removeBetOptionsSection()}>{getLabel('betslip_alt.fun_bonus.back')}</button>
                <button className="bonusButton" onClick={() => purchase()}>{getLabel('betslip_alt.fun_bonus.next')}</button>
            </div>
        </React.Fragment>
    );
}

export default BetOptionsSection;